const EVENT_PREFIX = "configurator_";

export const Events = {
	INIT: "init",
	SELECT_OPTION: "select_option",
	SELECT_PRODUCT: "select_product",
	SELECT_SIZE: "select_size",
	CHANGE_QUANTITY: "change_quantity",
	ADD_TO_CART: "add_to_cart"
};

export const pushEvent = (event, data) => {
	if (typeof window === "undefined" || !window) {
		return;
	}

	if (!window.dataLayer) window.dataLayer = [];

	window.dataLayer.push({
		event: `${EVENT_PREFIX}${event}`,
		custom_event: `${EVENT_PREFIX}${event}`,
		customDimensions: JSON.stringify({
			"UserSegment": "configurator"
		}),
		details: data ? formatDetails(data) : "{}"
	});

	window.dataLayer.push({event: null, details: null, customDimensions: null});
};

const formatDetails = (details) => {
	const formattedDetails = {};

	for (const [key, value] of Object.entries(details)) {
		formattedDetails[key] = String(value);
	}

	return JSON.stringify(formattedDetails);
};



// WEBPACK FOOTER //
// ./src/helpers/tracking.js